@use '@snowit/style/mixins';

.typo {
  margin: 0;
  padding: 0;
  font-family: var(--lff);
  font-size: clamp(var(--lfs-min), var(--lfs-increase) + var(--lfs-relative), var(--lfs-max));
  font-weight: var(--lfw);
  line-height: calc(1em + var(--llh));
  text-align: var(--lalign);
  text-decoration: var(--ldecoration);
  color: var(--lc);
  transition: var(--transition-025);
}

// If balancer
.balancer {
  text-wrap: balance;
}

// If ellipsis
.ellipsis {
  max-width: 100%;

  @include mixins.textOverflow;
}
